import { useEffect, useState } from "react";
import { useCustomerAnalytics } from "../../../../services/hooks/useCustomerAnalytics";
import { CUSTOMER_ANALYTICS_EVENT } from "../../../../utils/enums";
import styles from "./InputLocation.module.scss";

export const InputLocation = (props: {
  value: string | undefined;
  name: string;
  label: string;
  required: boolean;
  handleChange: (e: any) => void;
  validateInput: (input: string, required: boolean) => string | null;
  placeholder?: string;
  disabled?: boolean;
}) => {
  const {
    name,
    value,
    placeholder,
    label,
    handleChange,
    validateInput,
    required,
    disabled,
  } = props;
  const addCustomerAnalytics = useCustomerAnalytics();
  const [error, setError] = useState<string | null>(null);
  const [inputValue, setInputValue] = useState(value || "");

  useEffect(() => {
    setInputValue(value || "");

    setError(null);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);

    const validationError = validateInput(newValue, required);
    setError(validationError);

    handleChange({
      ...e,
      target: {
        ...e.target,
        name: e.target.name,
        value: newValue,
      },
    });
  };

  const handleBlur = () => {
    setError(validateInput(inputValue, required));
  };

  return (
    <div className={styles.input_wrapper}>
      <input
        name={name}
        value={inputValue}
        type="text"
        className={`${error ? styles.input_error : ""}`}
        required={required}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        onFocus={() => {
          addCustomerAnalytics(CUSTOMER_ANALYTICS_EVENT.ENTERED_DELIVERY_INFO, {
            inputField: name,
          });
        }}
        disabled={disabled}
      />
      <span className={styles.floating_label}>{label}</span>
      {error && <div className={styles.error_message}>{error}</div>}
    </div>
  );
};
